import { types } from "../constants/normalType";
const intialState = {
  getGiftCardShow: false,
  getEmployeeindex: 0,
};
export const normalReducer = (state = intialState, action) => {
  switch (action.type) {
    case types.GIFT_CARD_SHOW:
      return {
        ...state,
        getGiftCardShow: action.payload,
      };

    case types.EMPLOYEE_SELECTED_INDEX:
      return { ...state, getEmployeeindex: action.payload };
    default:
      return state;
  }
};
